export const SelectField = {
  parts: ['Control', 'Label', 'Select', 'HelperText'],
  baseStyle: {
    Control: {
      margin: '0',
      display: 'inline-block',
      verticalAlign: 'top',
    },
    Label: {
      textTransform: 'uppercase',
      fontSize: '12px',
      letterSpacing: '0.2em',
      color: 'brand.black',
      padding: '32px 0px 26px 0px',
      margin: 0,
      fontWeight: 700,
    },
    Select: {
      fontSize: '16px',
      fontWeight: 400,
      margin: 0,
      padding: '5px 15px',
      height: '3.5em',
      display: 'block',
    },
    HelperText: {},
  },
  variants: {
    '50%WidthShort': {
      Control: {
        width: '50%',
        paddingRight: '22px',
        marginTop: '32px',
        display: 'inline-block',
        verticalAlign: 'top',
      },
      Label: {
        fontSize: '12px',
        letterSpacing: '2px',
        textTransform: 'uppercase',
        padding: '0px 0px 21px 0px',
        margin: 0,
      },
      Select: {
        padding: '10px 16px',
        minHeight: '61px',
        margin: 0,
        border: '1px solid',
        borderColor: 'brand.midgrey2',
      },
    },
    '100to50%WidthShort': {
      Control: {
        width: ['100%', '50%'],
        paddingRight: '22px',
        marginTop: '32px',
        marginBottom: '10px',
        display: 'inline-block',
        verticalAlign: 'top',
      },
      Label: {
        fontSize: '12px',
        letterSpacing: '2px',
        textTransform: 'uppercase',
        padding: '0px 0px 21px 0px',
        margin: 0,
      },
      Select: {
        padding: '10px 16px',
        minHeight: '61px',
        margin: 0,
        border: '1px solid',
        borderColor: 'brand.midgrey2',
      },
    },
  },
};
